import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import classes from './ShareLink.module.css';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ShareLink = props => {
  const userInfo = useSelector(state => state.userInfo);

  const handleClose = () => {
    props.closeDialog();
  };

  const handlerCopyDegree = () => {
    const copyText = document.getElementById('urlDegreeCopy');
    navigator.clipboard
      .writeText(copyText.value)
      .then(() => {
        console.log('Texto copiado al portapapeles');
      })
      .catch(err => {
        console.error('Error al copiar al portapapeles:', err);
      });
  };

  return (
    <Dialog
      open={props.openDialog}
      TransitionComponent={Transition}
      onClose={handleClose}
      width="md"
      fullWidth="true"
    >
      <IconButton onClick={handleClose} className={classes.closeBtn}>
        <CloseIcon />
      </IconButton>
      <div className={classes.title}>
        <p>Comparte el enlace de pago para realizar la compra</p>
      </div>
      <DialogContent>
        <p className={classes.subTitle}>
          Comparte este enlace con la persona que realizará el pago
        </p>
        <p className={classes.text}>
          El correo asignado a esta compra es: {userInfo.data.email}
        </p>
        <p className={classes.text}>
          El usuario asignado a esta compra es:{' '}
          {userInfo.data.nombre}
        </p>
      </DialogContent>
      <div className={classes.btnsContainer}>
        <input
          type="text"
          id="urlDegreeCopy"
          value={`pagos.mayahii.com/payment/${props.link}`}
          className={classes.inputCode}
        />
        <Button
          onClick={handlerCopyDegree}
          className={classes.agreeBtn}
        >
          Copiar enlace de pago
        </Button>
      </div>
    </Dialog>
  );
};

ShareLink.propTypes = {
  // eslint-disable-next-line react/require-default-props
  openDialog: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  closeDialog: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  link: PropTypes.number
};

export default ShareLink;
